// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/index'
import { eventBus } from '../eventBus'
import { Toast } from 'vant';
import 'vant/lib/index.css';

// import Vconsole from 'vconsole'
//   new Vconsole()

Vue.prototype.$eventBus = eventBus
Vue.config.productionTip = false
Vue.use(Toast);

/* eslint-disable no-new */
// 解析 URL 中的 query（同时支持 window.location.search 与 hash 模式下的 query）
function parseQueryString(qs) {
  const res = {};
  if (!qs) return res;
  // 去掉开头的 ? 或 # 或 #/ 之类
  qs = qs.replace(/^\?|^#\/?/, '');
  qs.split('&').forEach(pair => {
    if (!pair) return;
    const idx = pair.indexOf('=');
    if (idx === -1) {
      res[decodeURIComponent(pair)] = '';
    } else {
      const key = decodeURIComponent(pair.slice(0, idx));
      const val = decodeURIComponent(pair.slice(idx + 1));
      res[key] = val;
    }
  });
  return res;
}

// 合并两处可能出现的 query：1) window.location.search, 2) hash 中的 query (例如 #/path?a=b)
function collectExternalParams() {
  const params = {};
  // 1. search（例如 index.html?token=...）
  Object.assign(params, parseQueryString(window.location.search));

  // 2. hash 后可能包含的 query（例如 #/input?token=...）
  const hash = window.location.hash || '';
  // 找到 hash 中 '?' 后面的部分
  const qIdx = hash.indexOf('?');
  if (qIdx !== -1) {
    const hashQuery = hash.slice(qIdx + 1);
    Object.assign(params, parseQueryString(hashQuery));
  }

  return params;
}

const externalParams = collectExternalParams();
// 期望的外部参数名：token, uid, phone（如果命名不同，请调整）
if (externalParams.token) {
  localStorage.setItem('token', externalParams.token);
}
if (externalParams.uid) {
  localStorage.setItem('uid', externalParams.uid);
}
if (externalParams.phone) {
  localStorage.setItem('phone', externalParams.phone);
}

const app = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});

// 启动后如果存在 token && uid，则无需登录，跳转到年审页面(`/input`)；
// 否则保持在登录页（路由默认设置为 '/' => login）。
if (localStorage.getItem('token') && localStorage.getItem('uid')) {
  // 如果当前路由是登录页则替换为年审页
  const curName = router.currentRoute && router.currentRoute.name;
  if (curName === 'login' || router.currentRoute.path === '/') {
    router.replace('/input');
  }
}



// WEBPACK FOOTER //
// ./src/main.js